import axios from 'axios';
import qs from 'qs';
import { Message, Notification } from 'element-ui';
import { sessionRead } from './global.js' // 自定公共函數
import router from './router'
if (process.env.NODE_ENV == 'development') {
    // axios.defaults.baseURL = 'https://demoapi.techtop.com.hk';
    axios.defaults.baseURL = 'http://devghapi.techtop.com.hk';
} else if (process.env.NODE_ENV == 'production') {
    // axios.defaults.baseURL = 'https://duofuapi.techtop.cc';
    axios.defaults.baseURL = 'https://ghapi.techtop.com.hk';
}
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.timeout = 30000;
const app_version = '1.00';
const serve_version = sessionRead('version');
export let apiurl = axios.defaults.baseURL;
// 请求拦截器
axios.interceptors.request.use(function (config) {
    let msoid = sessionRead('mso_id');
    let token = sessionRead('token');
    let username = sessionRead('username');
    let jsondata = {};
    if (msoid && token && username) {
        jsondata = {
            "username": username,
            "token": token,
            "msoid": msoid,
            "version": app_version
        };
    }
    config.headers.auth = JSON.stringify(jsondata);
    return config;
}, function (error) {
    return Promise.reject(error);
});
//响应拦截器

axios.interceptors.response.use(function (response) {
    let data = response.data;
    if (data == 'otherlogin') {
        Notification({
            message: 'The account has been logged in on other devices',
            type: 'error',
            duration: 6000,
            offset: 70
        });
        router.replace({
            path: 'Login'
        });
        return Promise.reject(response);
    } else if (data == 'version') {
        Notification({
            message: '系統當前版本為：' + app_version + '，請更新至版本：' + serve_version,
            type: 'error',
            duration: 6000,
            offset: 70
        });
        return Promise.reject(response);
    } else if (data == 'noauth') {
        Notification({
            message: 'No Auth',
            type: 'error',
            duration: 6000,
            offset: 70
        });
        return Promise.reject(response);
    }

    if (response.status === 200) {
        return Promise.resolve(response);
    } else {
        return Promise.reject(response);
    }
}, function (error) {
    return Promise.reject(error);
});
export function get (url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data)
        })
    });
}
export function post (url, params, config) {

    return new Promise((resolve, reject) => {
        if (config) {
            axios.post(url, params, config)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err.data)
                })
        } else {
            axios.post(url, qs.stringify(params))
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err.data)
                })
        }

    });
}